import { Component, EventEmitter, Input, Output } from "@angular/core";
import { fadeInOut } from "src/app/common/animations/animations";

@Component({
  selector: "app-instructions",
  templateUrl: "./instructions.component.html",
  styleUrls: ["./instructions.component.scss"],
  animations: [fadeInOut],
})
export class InstructionsComponent {
  @Output() onRoute = new EventEmitter<void>();
  @Input() isComponent: boolean = false;

  constructor() {}

  changeRoute() {
    this.onRoute.emit();
  }
}
